import React from 'react'
import { CollapsibleElement } from '../components'

const Courses = () => {
  const elements = [
    {
      title: "1. Poultry Production",
      paragraph: [
        "Discover the art of Poultry Production with our comprehensive course. Gain practical knowledge and hands-on training in breeding, nutrition, and disease management. Unleash your potential in this thriving industry and unlock rewarding career opportunities.",
        "Join our esteemed institution to learn the essentials of Poultry Production. Our experienced instructors will guide you through the lifecycle of poultry, from rearing to marketing. Be equipped with the skills to excel in this dynamic field and make a significant impact in the agricultural sector"
        ,"Enroll in our Poultry Production course and become a skilled professional in the booming poultry farming industry. Learn sustainable practices, emerging technologies, and industry trends. Open doors to diverse roles such as farm management, production supervision, and nutrition consultancy"
      ]
    },
    {
      title: "2. Small non-ruminant animals Production",
      paragraph:  [
        "Explore the world of Small Non-Ruminant Animals Production through our specialized course. Acquire practical knowledge and hands-on experience in raising small animals like poultry, rabbits, and guinea pigs. Unlock a world of opportunities in this rapidly growing sector and embark on a rewarding career in animal production",
        "Join our esteemed institution to master the essentials of Small Non-Ruminant Animals Production. Our experienced instructors will guide you through the intricacies of small animal rearing, nutrition, and health management. Gain valuable skills that will set you apart in the industry and open doors to various roles in animal farming and entrepreneurship",
        "Enroll in our Small Non-Ruminant Animals Production course and become a skilled professional in the field. Learn about efficient breeding practices, optimal feeding techniques, and disease prevention strategies for small animals. Prepare yourself for a fulfilling career in animal production, where you can contribute to the sustainable and ethical management of non-ruminant species"
      ]
    },
    {
      title: "3. Maize Production",
      paragraph:  [
        "Immerse yourself in the world of Maize Production through our specialized course. Gain practical knowledge and hands-on experience in cultivating maize, from seed selection to harvest. Uncover the secrets to maximizing yield and quality in this essential crop and pave the way for a successful career in agricultural production.",
        "Join our esteemed institution to master the essentials of Maize Production. Our experienced instructors will guide you through the entire maize cultivation process, including land preparation, planting techniques, nutrient management, and pest control. Acquire the skills and expertise necessary to become a proficient maize farmer and contribute to global food security.",
        "Enroll in our Maize Production course and become a skilled professional in the field of agricultural crop production. Learn about the latest advancements in hybrid maize varieties, precision farming technologies, and sustainable cultivation practices. Prepare yourself for a rewarding career as a maize producer, where you can make a significant impact on food production and contribute to the agricultural industry's growth and sustainability."
      ]
    },
    {
      title: "4. Winter cropping ",
      paragraph:  [
        "Immerse yourself in the world of Winter Cropping through our specialized course. Gain practical knowledge and hands-on experience in cultivating crops during the winter season. Discover the unique techniques and strategies required to successfully grow crops in colder climates. Expand your agricultural expertise and unlock new opportunities in winter crop production.",
        "Join our esteemed institution to master the essentials of Winter Cropping. Our experienced instructors will guide you through the intricacies of selecting appropriate winter crops, optimizing planting schedules, and implementing effective frost protection methods. Acquire the skills and knowledge necessary to become a proficient winter crop farmer and maximize your yield even during the coldest months.",
        "Enroll in our Winter Cropping course and become a skilled professional in the field of cold-season agriculture. Learn about winter crop varieties, soil management techniques, and crop rotation practices specifically tailored for winter conditions. Prepare yourself for a rewarding career where you can contribute to sustainable food production year-round and adapt to the unique challenges and opportunities of winter cropping."
      ]
    },
    {
      title: "5. Sheep and Goats Production ",
      paragraph:  [
        "Discover the art of Sheep and Goats Production through our specialized course. Gain practical knowledge and hands-on experience in raising and managing these valuable livestock species. Learn about breed selection, nutrition, health care, and breeding practices. Unlock a world of opportunities in the thriving sheep and goats industry and embark on a rewarding career as a livestock producer",
        "Join our esteemed institution to master the essentials of Sheep and Goats Production. Our experienced instructors will guide you through the intricacies of sheep and goat farming, from proper housing and pasture management to effective disease prevention and marketing strategies. Acquire the skills and expertise necessary to become a successful shepherd or goat herder, contributing to the sustainable production of meat, fiber, and dairy products from these versatile and resilient animals."
      ]
    },
    {
      title: "6. Soya Production ",
      paragraph:  [
        "Immerse yourself in the world of Soya Production through our specialized course. Gain practical knowledge and hands-on experience in cultivating and managing soybean crops. Explore the intricacies of soya production, from seed selection and planting techniques to pest and disease management. Unlock a world of opportunities in the booming soy industry and embark on a rewarding career as a soybean producer",
        "Join our esteemed institution to master the essentials of Soya Production. Our experienced instructors will guide you through the entire process, from soil preparation and fertilization to harvesting and post-harvest handling of soybeans. Learn about the latest advancements in soybean genetics, crop rotation practices, and sustainable farming methods. Acquire the skills and expertise necessary to become a successful soybean farmer, contributing to the production of this versatile and widely-used crop for various purposes, including food, feed, and industrial applications."
      ]
    },
    {
      title: "7. Sunflower Production ",
      paragraph:  [
      ]
    },
    {
      title: "8. Maize Production ",
      paragraph:  []
    },
    {
      title: "9. Tomato Production ",
      paragraph:  []
    },
    {
      title: "10. Cassava Production ",
      paragraph:  []
    },
    {
      title: "11. Groundnuts Production ",
      paragraph:  []
    },
    {
      title: "12. Tobacco Production ",
      paragraph:  []
    },
    {
      title: "13. Vegetable Production ",
      paragraph:  [
        
      ]
    },
    {
      title: "14. Pepper Production ",
      paragraph:  []
    },
    {
      title: "15. Vegetable Production ",
      paragraph:  []
    },
    {
      title: "16. Fruit Production ",
      paragraph:  []
    },
    {
      title: "17. Pig Farming",
      paragraph:  []
    },
    {
      title: "18. Quail farming",
      paragraph:  []
    },
    {
      title: "19. Rice Production",
      paragraph:  []
    },
    {
      title: "20. Watermelon Production",
      paragraph:  []
    }



  ]
  return (
    <div className={`flex flex-1 flex-col py-6 w-full p-5`}>
      <h1 className='text-[28pt] font-semibold text-center animate-bounce'>Courses Offered</h1>
      <div className='flex flex-col'>
        <p className='text-center text-lg my-3 w-[375px] md:w-full self-center'>
          Mlimi hub aims at training young people in Malawi in areas of agribusiness, livestock production, 
          agricultural Innovation, food processing through hands on learning and online platforms
          <br />
          <span className='font-bold'>Our innovation hub offers the following courses : </span>
        </p>

        <div className='flex flex-1 md:flex-row flex-col items-center flex-wrap justify-evenly gap-y-3 mt-3'>
          {
            elements.map((element, index) => (
              <CollapsibleElement title={element.title} key={index} paragraphs={element.paragraph}/>
            ))
          }
        </div>
      
      </div>
      
    </div>
  )
}

export default Courses
